(ns teamoesterreich.admin-mode.page-router
  (:require
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]
    [teamoesterreich.admin-mode.administration.help.help-admin :as help-admin]
    [teamoesterreich.admin-mode.administration.help.help-admin-list :as help-admin-list]

    [teamoesterreich.admin-mode.administration.help.help-page :as help-page]
    [teamoesterreich.admin-mode.administration.messages.message-list :as message-list]
    [teamoesterreich.admin-mode.administration.my-setup :as my-setup]
    [teamoesterreich.admin-mode.administration.organisation.organisation-list :as organisation-list]
    [teamoesterreich.admin-mode.administration.rights.rights-table :as rights-table]

    [teamoesterreich.admin-mode.can-you.can-you-overview :as can-you-overview]
    [teamoesterreich.admin-mode.can-you.can-you-sort-table :as can-you-sort-table]

    [teamoesterreich.admin-mode.content.blog-admin :as blog-admin]
    [teamoesterreich.admin-mode.content.blog-admin-list :as blog-admin-list]

    [teamoesterreich.admin-mode.content.news-admin :as news-admin]
    [teamoesterreich.admin-mode.content.news-admin-list :as news-admin-list]

    [teamoesterreich.admin-mode.crowdtasker.event-overview :as crowdtasker-event-overview]
    [teamoesterreich.admin-mode.crowdtasker.event-sort-table :as crowdtasker-event-sort-table]
    [teamoesterreich.admin-mode.crowdtasker.task-result.crowdtasker-task-result :as crowdtasker-task-result]

    [teamoesterreich.admin-mode.crowdtasker.task.crowdtasker-task-detail :as crowdtasker-task-detail]
    [teamoesterreich.admin-mode.dashboard.dashboard :as dashboard]
    [teamoesterreich.admin-mode.event.detail.event-overview :as event-overview]
    [teamoesterreich.admin-mode.event.event-sort-table :as event-sort-table]

    [teamoesterreich.admin-mode.event-alarm.event-alarm-table :as event-alarm-table]
    [teamoesterreich.admin-mode.event-alarm.detail.alarm-overview :as event-alarm-overview]

    [teamoesterreich.admin-mode.info.dsgvo :as dsgvo]
    [teamoesterreich.admin-mode.info.impressum :as impressum]

    [teamoesterreich.admin-mode.lebensretter.detail.lr-detail-form :as lr-detail-form]
    [teamoesterreich.admin-mode.lebensretter.incident.incident-list :as lr-incident]
    [teamoesterreich.admin-mode.lebensretter.lr-feed.lr-feed :as lr-feed]
    [teamoesterreich.admin-mode.lebensretter.lr-feed.lr-feed-list :as lr-feed-list]
    [teamoesterreich.admin-mode.lebensretter.lr-user.toe-list :as lr-toe-list]
    [teamoesterreich.admin-mode.lebensretter.opt-in.list :as lr-optIn-list]
    [teamoesterreich.admin-mode.questionnaire.questionnaire-form :as questionnaire-form]
    [teamoesterreich.admin-mode.questionnaire.questionnaire-sort-table :as questionnaire-sort-table]
    [teamoesterreich.admin-mode.selection.selection-list :as selection-list]
    [teamoesterreich.admin-mode.statistic.lebensretter-page :as statistic-lr-page]

    [teamoesterreich.admin-mode.text-blocks.text-block-form :as text-block-form]
    [teamoesterreich.admin-mode.text-blocks.text-block-list :as text-blocks]



    [teamoesterreich.admin-mode.toe-list.toe-list :as toe-list]
    [teamoesterreich.admin-mode.toe-map-list.toe-map-list :as toe-map-list]

    [teamoesterreich.admin-mode.toe-map-search.toe-map-search :as toe-map-search]
    [teamoesterreich.admin-mode.training.training-overview :as training-overview]

    [teamoesterreich.admin-mode.training.training-sort-table :as training-sort-table]
    [teamoesterreich.admin-mode.user.user-view :as user-view]
    [teamoesterreich.admin-mode.warnings.warnung-form :as warning-form]
    [teamoesterreich.admin-mode.warnings.warnung-list :as warning-list]

    [teamoesterreich.admin-mode.warnings.warnung-measure-setup :as warning-measure-setup]
    [teamoesterreich.view-state :as vstate]

    ["react-oidc-context" :as roc]

    )

  (:import (goog.i18n DateTimeSymbols_de_AT)))


(def DEACTIVATED [mui/paper
                  {:style {:height "200px" :backgroundImage "repeating-linear-gradient(45deg,white 0%,white 6%, #c2a183 6%,#c2a183 12%, white 12%)"}}
                  [:h1 "Komponente derzeit deaktiviert (Datenimport noch nicht abgeschlossen!)"]])

(defn logout-button [{:keys [onClose] :as props}]
  (let [auth (roc/useAuth)]
    [mui/menu-item {:onClick (fn []
                               (onClose)
                               (.signoutRedirect auth)
                               )}
     "Neu Anmelden"]))

(defn get-page []
  (fn []
    (let [!act-site (r/cursor vstate/app-state [:site])
          !help-mode (r/cursor vstate/app-state [:help-mode])
          !error (r/cursor vstate/app-state [:error])
          !error-status (r/cursor vstate/app-state [:error-status])
          !drawer-menu (r/cursor vstate/app-state [:show-menu])
          !load-state (r/cursor vstate/app-state [:load-state])]
      ;(log/debug "set Site to" @!act-site @!load-state)
      (if (= @!load-state :loading)
        (if @!error
          [:div {:style {:marginTop "100px"}}

           (if (= @!error-status 401)
             [:div
              [:h3 "Deine Session ist nicht mehr gültig! Bitte melde dich neu an."]
              [:f> logout-button]
              ]
             [:div
              [:h3 "Es ist ein Fehler aufgetreten!"]
              [:span "Fehler: " [:pre @!error]]
              ])

           ]
          [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."]
          )


        ^{:key "admin-mode-container"}
        [:div {:className "admin-mode-container"
               :style     {:width      (if @!drawer-menu "calc(100% - 270px)" "100%")
                           :marginLeft (if @!drawer-menu "270px" "0px")}}

         (if @!help-mode
           [(help-page/get-it @!act-site)]

           (case @!act-site

             :dashboard [(dashboard/get-it)]



             :toe-list (toe-list/get-it)

             :warning-edit [(warning-form/get-it)]
             :warning-list [(warning-list/get-it)]

             :warning-measure [(warning-measure-setup/get-it)]


             :map-list (toe-map-list/get-it)
             :map-search (toe-map-search/get-it)

             :user-view [(user-view/get-it)]

             :selection-list [(selection-list/get-it)]

             :event-list [event-sort-table/get-it]
             :event-overview [event-overview/get-it]
             :event-alarm [event-alarm-table/get-it]
             :event-alarm-overview [event-alarm-overview/get-it]

             :can-you-list [can-you-sort-table/get-it]
             :can-you-overview [(can-you-overview/get-it)]

             :crowdtasker-list [crowdtasker-event-sort-table/get-it]
             :crowdtasker-event-overview [(crowdtasker-event-overview/get-it)]
             :crowdtasker-task-detail [(crowdtasker-task-detail/get-it)]
             :crowdtasker-task-result [(crowdtasker-task-result/get-it)]


             :training-list [training-sort-table/get-it]
             :trainingEvent-overview [(training-overview/get-it)]

             :lebensretter [lr-toe-list/get-it]
             :lebensretter-incident [lr-incident/get-it]
             :lebensretter-detail-form [lr-detail-form/get-it]
             :lebensretter-feeds [lr-feed-list/get-it]
             :lebensretter-feed-item [(lr-feed/get-it)]
             :lebensretter-optIn [lr-optIn-list/get-it]


             :rights-manager [(rights-table/get-it)]
             :my-setup [(my-setup/get-it)]

             :help-admin-list [(help-admin-list/get-it)]
             :help-admin [(help-admin/get-it)]

             :text-blocks [(text-blocks/get-it)]
             :textBlock-edit [(text-block-form/get-it)]

             :blog-edit [(blog-admin/get-it)]
             :blog-list [(blog-admin-list/get-it)]

             :news-edit [(news-admin/get-it)]
             :news-list [(news-admin-list/get-it)]

             :questionnaire-list [questionnaire-sort-table/get-it]
             :questionnaire-form [(questionnaire-form/get-it)]

             :selectOptions DEACTIVATED

             :org-admin [(organisation-list/get-it)]
             :message-list [(message-list/get-it)]


             :statistic-lr [(statistic-lr-page/get-it)]

             :impressum (impressum/get-it)
             :dsgvo (dsgvo/get-it)

             ;default
             [(dashboard/get-it)]

             ;[:h5 "Bitte wähle eine Seite (Seite nicht gefunden: `" @!act-site "`)"]
             ))
         ]))))


